// compiled-reports/ is a public route; REACT_APP_URL points to the public-facing
// host (the editor may be hosted elsewhere). Without it, stay on this host: a
// hardcoded fallback would ship dead links if a build ever lacked the variable.
export const compiledReportUrl = (id) =>
  `${process.env.REACT_APP_URL || window.location.origin}/compiled-reports/${id}/`;
